import React from "react";

import { css } from "@emotion/css";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { FontSizes } from "@/assets/fonts.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";
import { Card } from "@/uiKit/atoms/card/Card.tsx";
import { CardContent } from "@/uiKit/atoms/card/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/card/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/card/CardHeader.tsx";
import { ContactSupportInfo } from "@/uiKit/organisms/ContactSupport.tsx";

const BROWSERS: ReadonlyArray<{
  labelKey: string;
  href: string;
  icon: string;
}> = [
  {
    labelKey: "usb.downloadChrome",
    href: "https://www.google.fr/chrome/index.html",
    icon: "https://www.google.fr/chrome/static/images/chrome-logo-m100.svg",
  },
  {
    labelKey: "usb.downloadEdge",
    href: "https://www.microsoft.com/en-gb/edge/download",
    icon: "https://edgestatic.azureedge.net/shared/cms/lrs1c69a1j/section-images/2c3f3c46bd764335beec466a0acfde0e-png-w639.avif",
  },
  {
    labelKey: "usb.downloadOpera",
    href: "https://www.opera.com/download/",
    icon: "https://cdn-production-opera-website.operacdn.com/staticfiles/assets/images/favicon/opera/favicon-32x32.a769c19798b2.png",
  },
];

export const UnsupportedBrowserPage: React.FC = () => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();
  const supportInfo = Queries.config.useSupportInfo({});

  return (
    <Card className={styles.container}>
      <CardHeader title={t("usb.usbRequired")} />
      <CardContent className={styles.content}>
        <Typography variant="body" className={styles.bodyText}>
          {t("usb.usbRequiredInstructions")}
        </Typography>
        <Typography component="span">
          {t("support.inCaseOfNeed")}
          <ContactSupportInfo support={supportInfo} />
        </Typography>
      </CardContent>
      <CardFooter>
        {BROWSERS.map(({ labelKey, href, icon }) => (
          <Button key={labelKey} variant="outlined" component="a" href={href} target="_blank" rel="noopener noreferrer">
            <img src={icon} alt={labelKey} className={styles.browserIcon} />
            {t(labelKey)}
          </Button>
        ))}
      </CardFooter>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css({
    margin: theme.spacing(32),
  }),
  content: css({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(8),
  }),
  bodyText: css({
    whiteSpace: "pre-line",
  }),
  browserIcon: css({
    width: FontSizes.h6,
    height: FontSizes.h6,
    marginRight: theme.spacing(2),
  }),
});
